import { SVGProps } from 'react'

export const SwingIcon1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1064'
    height='496'
    viewBox='0 0 1064 496'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M6 755.093C703.083 651.771 1276.62 813.046 876.964 742.321C232.719 628.312 1393.18 170.01 967.449 283.115C272.153 467.838 572.486 97.1707 1197.28 40.1657'
      stroke='currentColor'
      strokeWidth='80'
    />
  </svg>
)

export const SwingIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='750'
    height='494'
    viewBox='0 0 750 494'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M5 610.192C570.506 526.373 1035.78 657.207 711.566 599.832C188.925 507.342 1130.34 135.547 784.971 227.303C220.915 377.158 464.559 76.456 971.419 30.211'
      stroke='currentColor'
      strokeWidth='60'
    />
  </svg>
)
